import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs/operators";
import { CompanyService } from "../../portal/company-api/services/company.service";
import * as CompanyActions from "./company.actions";

@Injectable()
export class CompanyEffects {
  initializeAction$;
  purchaseCompanyAction$
    constructor( private actions: Actions, private companyService: CompanyService) {
      this.initializeAction$ = createEffect(() => this.actions.pipe(
        ofType(CompanyActions.InitializeAction),
        switchMap(action => this.companyService.loadCompany({ id: action.companyId })),
        map(company => CompanyActions.MergeStateAction({ newState: { currentCompany: company } })),
    ));

    this.purchaseCompanyAction$ = createEffect(() => this.actions.pipe(
        ofType(CompanyActions.PurchaseCompanyAction),
        switchMap(action => this.companyService.loadCompany({ id: action.companyId })),
        map(company => CompanyActions.MergeStateAction({ newState: { currentCompany: company } })),
    ));
    }


}
